import { type PostNonCustodialProviderManagementPaymasterSecretPayload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { ncWalletApi } from '../api';

export const usePostNonCustodialProviderManagementPaymasterSecretQuery = () => {
	const { data, error, isError, isPending, isSuccess, mutate } = useMutation({
		mutationFn: async (params: PostNonCustodialProviderManagementPaymasterSecretPayload) => {
			const { data } = await (await ncWalletApi).postNon_custodial_provider_managementPaymasterSecret(params);

			return data;
		},
		mutationKey: ['webhook-secret']
	});

	return {
		data,
		error,
		isError,
		isPending,
		isSuccess,
		mutate
	};
};
